import React from "react";

import FormFactory from "../../../../components/form/form-factory";

import * as S from "./styles";

import IProps from "./props";

import logo from "../../../../assets/images/logo.png";

const Login = ({ onSubmit, dataForm, errorMessage }: IProps): JSX.Element => (
  <S.Container>
    <S.Logo src={logo} alt="Logo" />
    <S.SubTitle>Seja bem vindo!</S.SubTitle>
    <S.Title>Realize seu Login</S.Title>
    <FormFactory
      data={dataForm}
      onSubmit={onSubmit}
      submitErrorMessage={errorMessage}
    />
  </S.Container>
);
export default Login;
